import React, { FC } from "react";
import classNames from "classnames";
import { usePageTranslation } from "@app/hooks";
import { Hero } from "../common";
import { PressContact } from "./components/press-contact/PressContact";
import { CommunicationWays } from "./components/communication-ways/CommunicationWays";

export const Contact: FC = () => {
  const { t } = usePageTranslation();

  return (
    <div
      className={classNames(
        "min-h-screen w-full space-y-15 pb-15",
        "lg:mx-auto lg:max-w-container-wide lg:space-y-25 lg:pb-25",
        "xl:space-y-40 xl:pb-40",
      )}
    >
      <Hero title={t("hero_title")} />
      <CommunicationWays />
      <PressContact />
    </div>
  );
};
